export default {
      id: "became-active-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#became-active",
      toString: function () {
        return this.url;
      }
    }